// extracted by css-extract-rspack-plugin
export default {"zoomLevelMenuOverlay":"roadmap-zoom-level-menu-module__zoomLevelMenuOverlay__KCDddSW"};